import styled from 'styled-components'

import { Text } from '@radix-ui/themes'

export const UnselectableText = styled(Text)`
    user-select: none;
`
